import api from './axiosConfig';

export interface fetchHVACallTranscriptionParams {
  id: string;
  campaignid: number;
}

export interface fetchHVACallScorecardParams {
  callid: string;
  campaignid: number;
}

export interface fetchHVAScorecardDashData1Params {
  scorecardid: number;
  serviceid: number;
  campaignid: number;
  agentid: number;
  datefrom: Date;
  dateto: Date;
}

export interface fetchHVAScorecardDashData4Params {
  scorecardid: number;
  questionid: number;
  serviceid: number;
  campaignid: number;
  agentid: number;
  datefrom: Date;
  dateto: Date;
}

export const fetchHVAScorecardNames = async () => {
  try {
    const response = await api.get('/qamanagement/scorecardnames');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch Scorecard names: ', error);
    throw error;
  }
};

export const fetchHVAScorecardQuestions = async (scorecardid: number) => {
  try {
    const response = await api.post('/qamanagement/scorecardquestions', {
      scorecardid
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch Scorecard questions: ', error);
    throw error;
  }
};

export const fetchHVAScorecardQuestionAvgScore = async (
  params: fetchHVAScorecardDashData4Params
) => {
  try {
    const response = await api.post(
      '/qamanagement/scorecardquestionavgscore',
      params
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch Scorecard question score: ', error);
    throw error;
  }
};

export const fetchHVAScorecardQuestionsData = async (params: {
  scorecardid: number;
  serviceid?: number;
  campaignid?: number;
  agentid?: number;
  datefrom: Date;
  dateto: Date;
}) => {
  const response = await api.post(
    '/qamanagement/scorecardquestionsdata',
    params
  );
  return response.data;
};

export const fetchHVAScorecardDashData1 = async (
  params: fetchHVAScorecardDashData1Params
) => {
  try {
    const response = await api.post(
      '/qamanagement/scorecardsummarydata',
      params
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch Scorecard Dashboard summary data: ', error);
    throw error;
  }
};

export const fetchHVAScorecardDashEvolutionData = async (
  params: fetchHVAScorecardDashData1Params
) => {
  try {
    const response = await api.post(
      '/qamanagement/scorecardscoreevolution',
      params
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch Score evolution data: ', error);
    throw error;
  }
};

export const fetchHVAScorecardQuestionDashEvolutionData = async (
  params: fetchHVAScorecardDashData4Params
) => {
  try {
    const response = await api.post(
      '/qamanagement/scorecardquestionscoreevolution',
      params
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch Score evolution data: ', error);
    throw error;
  }
};

export const fetchHVAScorecardDashScoreVsDuration = async (
  params: fetchHVAScorecardDashData1Params
) => {
  try {
    const response = await api.post(
      '/qamanagement/scorecardscorevsduration',
      params
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch Score evolution data: ', error);
    throw error;
  }
};

export const fetchHVAScorecardDashScoreDistribution = async (
  params: fetchHVAScorecardDashData1Params
) => {
  try {
    const response = await api.post(
      '/qamanagement/scorecarddistribution',
      params
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch Score evolution data: ', error);
    throw error;
  }
};

export const fetchHVACallTranscription = async (
  params: fetchHVACallTranscriptionParams
) => {
  try {
    const response = await api.post('/qamanagement/calltranscription', params);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch call transcription and summary: ', error);
    throw error;
  }
};

export const fetchHVACallScorecard = async (
  params: fetchHVACallScorecardParams
) => {
  try {
    const response = await api.post(
      '/qamanagement/callstandardscorecard',
      params
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch call scorcards: ', error);
    throw error;
  }
};

export const fetchHVACallOpenQuestions = async (
  params: fetchHVACallScorecardParams
) => {
  try {
    const response = await api.post('/qamanagement/callopenquestions', params);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch open questions: ', error);
    throw error;
  }
};
